export default __webpack_public_path__ + "static/media/andes_a_la_costa_23.11ae7f09.jpg";